import React from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Button } from "primereact/button";
import DashboardLayout from "../../../layouts/DashboardLayout";
import Loading from "../../../../../components/Loading/Loading";
import localeText from "../../../../../locale";
import { formatPrice } from "../../../../../utilities/formatPrice";
import { EXTRAPAY_PATH, extrapayTabPath } from "./constants";
import { formatExtrapayDateTime } from "./formatExtrapay";
import useExtrapayWithdrawals from "./hooks/useExtrapayWithdrawals";
import ExtrapayBreadcrumb from "./components/ExtrapayBreadcrumb";
import ExtrapayPageHeader from "./components/ExtrapayPageHeader";
import ExtrapayDetailRows from "./components/ExtrapayDetailRows";
import ExtrapayInfoNote from "./components/ExtrapayInfoNote";
import ExtrapayStatusBadge from "./components/ExtrapayStatusBadge";

const displayName = (userInfo, withdrawal) => {
  const fullName = [userInfo?.firstname, userInfo?.surname].filter(Boolean).join(" ");
  return fullName || withdrawal?.username || "";
};

const ExtrapayWithdrawDetailsPage = ({ userInfo }) => {
  const { id } = useParams();
  const history = useHistory();
  const location = useLocation();
  const { withdrawals, isLoading } = useExtrapayWithdrawals();
  const withdrawal =
    withdrawals.find((item) => String(item.id) === String(id)) || location.state?.withdrawal;

  return (
    <DashboardLayout>
      <ExtrapayBreadcrumb
        items={[
          { labelKey: "financial", to: "/dashboard-financeiro" },
          { labelKey: "extrapayFlowTitle", to: EXTRAPAY_PATH },
          { labelKey: "extrapayFlowWithdrawalsCrumb", to: extrapayTabPath("saques") },
          { labelKey: "extrapayFlowDetailsCrumb" },
        ]}
      />
      <ExtrapayPageHeader
        title={localeText("extrapayFlowWithdrawDetailsTitle", { id: withdrawal?.id || id })}
        subtitle={localeText("extrapayFlowWithdrawDetailsSubtitle")}
      />

      {isLoading && !withdrawal ? (
        <div className="flex justify-content-center py-6">
          <Loading classNameIcon="text-6xl" />
        </div>
      ) : !withdrawal ? (
        <p className="text-sm">{localeText("extrapayFlowWithdrawNotFound")}</p>
      ) : (
        <div className="border-round-lg p-4" style={{ border: "1px solid var(--theme-border, #EBEBEB)" }}>
          <ExtrapayStatusBadge
            labelKey={withdrawal.status === "REQUESTED" ? "extrapayFlowStatusRequested" : "extrapayFlowStatusAwaiting"}
            tone="warning"
          />
          <div className="mt-2">
            <ExtrapayDetailRows
              rows={[
                { label: localeText("extrapayFlowRequest"), value: withdrawal.id },
                {
                  label: localeText("extrapayFlowRequestDate"),
                  value: formatExtrapayDateTime(withdrawal.dateRequest),
                },
                { label: localeText("extrapayFlowUser"), value: displayName(userInfo, withdrawal) },
                {
                  label: localeText("extrapayFlowWithdrawValue"),
                  value: localeText("extrapayFlowExcAmount", { amount: formatPrice(Number(withdrawal.amount) || 0) }),
                },
                {
                  label: localeText("extrapayFlowPlatformDebit"),
                  value: localeText("extrapayFlowExcAmount", { amount: formatPrice(Number(withdrawal.amount) || 0) }),
                },
                { label: localeText("extrapayFlowNetwork"), value: localeText("extrapayFlowNetworkName") },
                { label: localeText("extrapayFlowInformedAddress"), value: withdrawal.addressEXC },
                {
                  label: localeText("extrapayFlowSituation"),
                  value:
                    withdrawal.status === "REQUESTED"
                      ? localeText("extrapayFlowStatusAwaiting")
                      : withdrawal.status,
                },
              ]}
            />
          </div>
          <div className="mt-3">
            <ExtrapayInfoNote text={localeText("extrapayFlowSuccessNote")} />
          </div>
        </div>
      )}

      <Button
        label={localeText("extrapayFlowBackToWithdrawals")}
        className="mt-4 border-round-md border-none"
        style={{ backgroundColor: "var(--theme-primary, #1DAF61)", color: "#fff" }}
        onClick={() => history.push(extrapayTabPath("saques"))}
      />
    </DashboardLayout>
  );
};

export default ExtrapayWithdrawDetailsPage;
